<ng-container *ngIf="cardToken$ | async as cardToken; else addCard">
  <div
    class="ecash-button bg-glass d-flex justify-content-between align-item-center"
    [ngClass]="{
      'bg-frozen': cardToken.Frozen,
    }"
  >
    <div class="card-token-number text-white">
      <ng-container [ngSwitch]="cardToken?.CardType">
        <img
          class="card-type-image"
          *ngSwitchCase="1"
          [src]="'payment-icons/mastercard.svg' | contentAssetImage"
        />
        <img
          class="card-type-image"
          *ngSwitchCase="2"
          [src]="'payment-icons/amex.svg' | contentAssetImage"
        />
        <img
          class="card-type-image visa"
          *ngSwitchCase="3"
          [src]="'payment-icons/visa.svg' | contentAssetImage"
        />
        <img
          class="card-type-image"
          *ngSwitchCase="4"
          [src]="'payment-icons/discover.svg' | contentAssetImage"
        />
        <img
          class="card-type-image"
          *ngSwitchCase="5"
          [src]="'payment-icons/jcb.svg' | contentAssetImage"
        />
        <img
          class="card-type-image"
          *ngSwitchCase="7"
          [src]="'payment-icons/dinnersclub.svg' | contentAssetImage"
        />
        <img
          class="card-type-image"
          *ngSwitchCase="8"
          [src]="'payment-icons/unionpay.svg' | contentAssetImage"
        />
        <img
          class="card-type-image paypal-logo"
          *ngSwitchDefault
          [src]="'providers/paypal.svg' | contentAssetImage"
        />
      </ng-container>

      ({{ cardToken.CardNumber.substr(12) }})
      <span *ngIf="cardToken.ProviderId !== 35 && cardToken.ExpiryDate">
        {{ "payment.card.expiry.date" | translate }}
        {{ cardToken.ExpiryDate | date : "MM/yy" }}</span
      >
    </div>

    <a
      class="d-flex text-white"
      [ngClass]="{ 'text-white': cardToken.Frozen }"
      [routerLink]="'/payment'"
    >
      <span class="icon material-icons text-white">chevron_right</span>
    </a>
  </div>
</ng-container>

<ng-template #addCard>
  <div class="ecash-button bg-glass">
    <a
      class="btn d-flex align-item-center justify-content-center text-white"
      [routerLink]="'/payment'"
    >
      <span class="icon material-icons pe-2">add_card</span>
      <span class="font-size-14 add-card-text">{{
        "member.card.ecash.add" | translate
      }}</span>
    </a>
  </div>
</ng-template>
